import { IRbac } from '../../apis/__shared/rbac.interfaces';

export const mockRbacAdmin: IRbac = {
  dashboard: {
    finance: {
      read: true,
      write: true,
      delete: true,
    },
    people: {
      read: true,
      write: true,
      delete: true,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
  },
  students: {
    studentList: {
      read: true,
      write: true,
      delete: true,
    },
    attendance: {
      read: true,
      write: true,
      delete: true,
    },
    fees: {
      read: true,
      write: true,
      delete: true,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    scores: {
      read: true,
      write: true,
      delete: true,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  staff: {
    staffList: {
      read: true,
      write: true,
      delete: true,
    },
    attendance: {
      read: true,
      write: true,
      delete: true,
    },
    payouts: {
      read: true,
      write: true,
      delete: true,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
  },
  academics: {
    curriculum: {
      read: true,
      write: true,
      delete: true,
    },
    schedules: {
      read: true,
      write: true,
      delete: true,
    },
    lessonPlans: {
      read: true,
      write: true,
      delete: true,
    },
    materials: {
      read: true,
      write: true,
      delete: true,
    },
    assessments: {
      read: true,
      write: true,
      delete: true,
    },
    library: {
      read: true,
      write: true,
      delete: true,
    },
  },
  communications: {
    messaging: {
      read: true,
      write: true,
      delete: true,
    },
    announcements: {
      read: true,
      write: true,
      delete: true,
    },
    concerns: {
      read: true,
      write: true,
      delete: true,
    },
    events: {
      read: true,
      write: true,
      delete: true,
    },
    meetings: {
      read: true,
      write: true,
      delete: true,
    },
  },
  finance: {
    financeList: {
      read: true,
      write: true,
      delete: true,
    },
    scholarships: {
      read: true,
      write: true,
      delete: true,
    },
    financialReports: {
      read: true,
      write: true,
      delete: true,
    },
  },
  analytics: {
    performance: {
      read: true,
      write: true,
      delete: true,
    },
    customDashboards: {
      read: true,
      write: true,
      delete: true,
    },
  },
  administration: {
    transport: {
      read: true,
      write: true,
      delete: true,
    },
    inventory: {
      read: true,
      write: true,
      delete: true,
    },
    healthAndSafety: {
      read: true,
      write: true,
      delete: true,
    },
  },
  users: {
    parents: {
      read: true,
      write: true,
      delete: true,
    },
    visitors: {
      read: true,
      write: true,
      delete: true,
    },
    guests: {
      read: true,
      write: true,
      delete: true,
    },
    internalUsers: {
      read: true,
      write: true,
      delete: true,
    },
  },
  settings: {
    userManagement: {
      read: true,
      write: true,
      delete: true,
    },
    complianceManagement: {
      read: true,
      write: true,
      delete: true,
    },
  },
  profile: {
    personalDetails: {
      read: true,
      write: true,
      delete: false,
    },
    documents: {
      read: true,
      write: true,
      delete: true,
    },
    calendar: {
      read: true,
      write: true,
      delete: true,
    },
    leaves: {
      read: true,
      write: true,
      delete: true,
    },
  },
  guardian: {
    dashboard: { read: false, write: false, delete: false },
    academicsSchedule: { read: false, write: false, delete: false },
    academicsCurriculum: { read: false, write: false, delete: false },
    academicsLessonPlans: { read: false, write: false, delete: false },
    academicsMaterials: { read: false, write: false, delete: false },
    academicsAssessments: { read: false, write: false, delete: false },
    academicsHomework: { read: false, write: false, delete: false },
    academicsAttendance: { read: false, write: false, delete: false },
    academicsLibrary: { read: false, write: false, delete: false },
    fees: { read: false, write: false, delete: false },
    transport: { read: false, write: false, delete: false },
    documents: { read: false, write: false, delete: false },
    eventsCommunication: { read: false, write: false, delete: false },
    concerns: { read: false, write: false, delete: false },
    profile: { read: false, write: false, delete: false },
    settings: { read: false, write: false, delete: false },
  },
};
